(function () {
  /* ---------------------------------------------------------------------------
   * 1. Filtered product count sync
   * Copies the toolbar count into .total_filtered_products whenever it changes.
   * ------------------------------------------------------------------------- */
  var previousTotalCount = null;

  function readToolbarCount() {
    var countEl = document.querySelector('.collection-toolbar__products-count');
    return countEl ? parseInt(countEl.textContent, 10) : NaN;
  }

  function setFilteredCount(count) {
    if (isNaN(count)) return; // never write "NaN" into the page
    document.querySelectorAll('.total_filtered_products').forEach(function (el) {
      el.textContent = count;
    });
  }

  function syncCount() {
    var totalCount = readToolbarCount();
    if (isNaN(totalCount)) return;
    if (totalCount !== previousTotalCount) {
      previousTotalCount = totalCount;
      setFilteredCount(totalCount);
    }
  }

  function initCountSync() {
    // Only run on pages that actually have the count elements (collection/search pages)
    if (!document.querySelector('.collection-toolbar__products-count') && !document.querySelector('.total_filtered_products')) {
      return;
    }
    syncCount();
    setInterval(syncCount, 500);
  }

  /* ---------------------------------------------------------------------------
   * 2. Filter drawer clicks
   * Keeps the drawer checkbox state correct and mirrors the click to the sidebar.
   * ------------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var label = event.target.closest('.facets-drawer .checkbox-control label');
    if (!label) return;

    var clickedLabel = label.textContent;
    var input = label.previousElementSibling;

    // window.first_visit is defined in theme.liquid
    if (window.first_visit === false && input && input.matches('input')) {
      if (input.checked) {
        input.checked = false;
        input.removeAttribute('checked');
      } else {
        input.checked = true;
        input.setAttribute('checked', 'checked');
      }
    }

    window.first_visit = false;

    var totalCount = readToolbarCount();
    if (!isNaN(totalCount)) {
      previousTotalCount = totalCount;
      setFilteredCount(totalCount);
    }

    setTimeout(function () {
      // Match by attribute value directly, so labels containing quotes (e.g. "Kid's") don't break
      document.querySelectorAll('.facets-sidebar .checkbox-control label[data-label]').forEach(function (sidebarLabel) {
        if (sidebarLabel.getAttribute('data-label') === clickedLabel) {
          sidebarLabel.click();
        }
      });
    }, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountSync);
  } else {
    initCountSync();
  }
})();